import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var FormatBoldOutlineIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M15.38 10.845c.355-.371.636-.814.829-1.302A4.217 4.217 0 0016.5 8c0-2.206-1.682-4-3.75-4H6v1.6h1.5v12.8H6V20h7.5c2.482 0 4.5-2.153 4.5-4.8a5.04 5.04 0 00-.713-2.586 4.605 4.605 0 00-1.907-1.77zM12.75 5.6C13.99 5.6 15 6.677 15 8s-1.01 2.4-2.25 2.4H9V5.6h3.75zm.75 12.8H9V12h4.5c1.655 0 3 1.435 3 3.2 0 1.765-1.345 3.2-3 3.2z", fill: "currentColor" })] })));
};

export { FormatBoldOutlineIcon };
//# sourceMappingURL=FormatBoldOutlineIcon.js.map
